import _ from 'lodash';

/**
 * Return an error payload based on the error request received from axios
 * @param {object} error The error object from axios
 */
export const buildErrorPayload = (error) => {
  const payload = {
    errorMessage: _.get(error, 'response.data.message', 'An unknown error occurred. Please try again.'),
    code: _.get(error, 'response.data.code', 999)
  };

  return payload;
}